import { baseRequest } from '@thrivadev/thriva-request';
import { SHOP_ORDERS_API_PATH, RESET_SHOP_ORDERS_API_PATH } from './helpers';
/**
 *
 * @param customParams - Optional: An array of custom parameters to include in the request.
 * @returns A Promise<Order>
 */
export function resetOrder(orderId, apiOptions) {
    const requestOptions = {
        method: 'POST'
    };
    return baseRequest(`${SHOP_ORDERS_API_PATH}/${orderId}/${RESET_SHOP_ORDERS_API_PATH}`, requestOptions, apiOptions);
}
//# sourceMappingURL=reset.js.map